import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LanguageType } from '../models/common/language-type.enum';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private _languageType: LanguageType = undefined;
  private subject = new BehaviorSubject(this._languageType);
  private _languageType$: Observable<string> = this.subject.asObservable();

  constructor(
      private matDatepickerIntl: MatDatepickerIntl,
      private matPaginatorIntl: MatPaginatorIntl
    ) { }

  translateDatepicker() {
    return this.languageType$.pipe(
      tap(lang => {
        this.matDatepickerIntl.calendarLabel = lang === 'en' ? 'Calendar' : 'Calendrier';
        this.matDatepickerIntl.openCalendarLabel = lang === 'en' ? 'Open the calendar' : 'Ouvrir calendrier';
        this.matDatepickerIntl.prevMonthLabel = lang === 'en' ? 'Previous month' : 'Mois précédent';
        this.matDatepickerIntl.nextMonthLabel = lang === 'en' ? 'Next month' : 'Mois prochain';
        this.matDatepickerIntl.prevYearLabel = lang === 'en' ? 'Previous year' : 'Année précédente ';
        this.matDatepickerIntl.nextYearLabel = lang === 'en' ? 'Next year' : 'Année prochaine';
        this.matDatepickerIntl.prevMultiYearLabel = lang === 'en' ? 'Previous multi-year' : 'Pluriannuel précédent';
        this.matDatepickerIntl.nextMultiYearLabel = lang === 'en' ? 'Next multi-year' : 'Pluriannuel prochain';
        this.matDatepickerIntl.switchToMonthViewLabel = lang === 'en' ? 'Switch to month view' : 'Changer à l’affichage mensuel ';
        this.matDatepickerIntl.switchToMultiYearViewLabel = lang === 'en' ? 'Switch to year view' : 'Changer à l’affichage annuel';
      }));
  }

  translatePaginator() {
    return this.languageType$.pipe(
      tap(lang => {
        this.matPaginatorIntl.itemsPerPageLabel = lang === 'en' ? 'Results per page' : '[fr] Results per page';
        this.matPaginatorIntl.firstPageLabel = lang === 'en' ? 'First page' : '[fr] First page';
        this.matPaginatorIntl.lastPageLabel = lang === 'en' ? 'Last page' : '[fr] Last page';
        this.matPaginatorIntl.nextPageLabel = lang === 'en' ? 'Next page' : '[fr] Next page';
        this.matPaginatorIntl.previousPageLabel = lang === 'en' ? 'Previous page' : '[fr] Previous page';

        this.matPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) =>  {
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          var lang = this._languageType === 'en' ? ' of ' : ' de ';
          return `${startIndex + 1}` + ` - ` + `${endIndex}` + lang + `${length}`;;
      }
      }));
  }

  get languageType() {
    return this._languageType;
  }

  set languageType(languageType: LanguageType) {
    this._languageType = languageType;
    this.subject.next(this._languageType);
  }

  get languageType$() {
    return this._languageType$;
  }
}
